import { render, staticRenderFns } from "./LDataTable.vue?vue&type=template&id=0752cf34&scoped=true"
import script from "./LDataTable.vue?vue&type=script&lang=js"
export * from "./LDataTable.vue?vue&type=script&lang=js"
import style0 from "./LDataTable.vue?vue&type=style&index=0&id=0752cf34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0752cf34",
  null
  
)

export default component.exports